var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$helpers.inIframe()
    ? _c(
        "footer",
        {
          class: { "mt-3": _vm.marginTopActive, "mt-lg-5": _vm.marginTopActive }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "links-block",
                  attrs: {
                    xl: _vm.links.thirdColumn ? 3 : 6,
                    md: "6",
                    sm: "12"
                  }
                },
                [
                  _c(
                    "div",
                    _vm._l(_vm.links.firstColumn, function(link, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !link.hide,
                              expression: "!link.hide"
                            }
                          ],
                          key: index
                        },
                        [
                          _vm.isExternalLink(link.href)
                            ? _c(
                                "a",
                                {
                                  attrs: { target: "_blank", href: link.href }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(link.text) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _c("router-link", { attrs: { to: link.href } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(link.text) +
                                    "\n            "
                                )
                              ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "links-block mt-3 mt-md-0",
                  attrs: { xl: "3", md: "6", sm: "12" }
                },
                [
                  _c(
                    "div",
                    _vm._l(_vm.links.secondColumn, function(link, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !link.hide,
                              expression: "!link.hide"
                            }
                          ],
                          key: index
                        },
                        [
                          _vm.isExternalLink(link.href)
                            ? _c(
                                "a",
                                {
                                  attrs: { target: "_blank", href: link.href }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(link.text) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _c("router-link", { attrs: { to: link.href } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(link.text) +
                                    "\n            "
                                )
                              ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _vm.links.thirdColumn
                ? _c(
                    "b-col",
                    {
                      staticClass: "links-block mt-3 mt-md-0",
                      attrs: { xl: "3", md: "6", sm: "12" }
                    },
                    [
                      _c(
                        "div",
                        _vm._l(_vm.links.thirdColumn, function(link, index) {
                          return _c(
                            "span",
                            { key: index },
                            [
                              _vm.isExternalLink(link.href)
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href: link.href
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(link.text) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _c(
                                    "router-link",
                                    { attrs: { to: link.href, tag: "a" } },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(link.text) +
                                          "\n            "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "logo logo-footer mt-3 mt-xl-0",
                  attrs: { xl: "3", md: "12", sm: "12" }
                },
                [
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "d-block",
                        attrs: { target: "_blank", href: _vm.href }
                      },
                      [_c("img", { attrs: { src: _vm.logo } })]
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row", { staticClass: "cert-icons-footer mt-3" }, [
            _c("div", [
              _c("img", {
                staticClass: "middle-icon",
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/Logo/gdpr.webp"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", [
              _c("img", {
                staticClass: "first-icon",
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/Logo/hipaa.png"
                }
              })
            ]),
            _vm._v(" "),
            _vm.isHealthApp ? _c("div", [_c("ISO27001Logo")], 1) : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("router-link", { attrs: { to: "/programa-pyme" } }, [
                  _c("img", {
                    staticClass: "last-icon",
                    attrs: {
                      src: "/static-appopensalud/img/logos/programapyme.png"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "social-icons py-xl-5 mt-3" },
            [
              _c(
                "b-col",
                { attrs: { xl: "3", sm: "12" } },
                [
                  _vm._l(_vm.socialLinks, function(link, index) {
                    return _c(
                      "a",
                      {
                        key: index,
                        attrs: { target: "_blank", href: link.href }
                      },
                      [_c("img", { attrs: { src: link.src, alt: link.alt } })]
                    )
                  }),
                  _vm._v(" "),
                  _c("AddToHomeScreen", {
                    staticClass: "mt-3",
                    attrs: { white: "" }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "copyright mt-3 mt-xl-0",
                  attrs: { xl: "9", sm: "12" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("group-links", { staticClass: "d-block mb-4" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "overline-typescale",
                          class: {
                            "d-block": true,
                            "text-right": !_vm.$uiHelpers.isMobile
                          }
                        },
                        [
                          _vm._v(
                            "Copyright © " +
                              _vm._s(new Date().getFullYear()) +
                              " " +
                              _vm._s(_vm.companyName) +
                              ". " +
                              _vm._s(_vm.$t("all-rights"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3604ef0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3604ef0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseFooter.vue
// module id = 2517
// module chunks = 16 17 18 19 20 21 22 23 30 31 40